__turbopack_context__.v({
  "MapContainer": "GMjPNG_MapContainer",
});
